(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.google-reviews';

    function update(section) {
      const list = section.querySelector('.google-reviews__list');
      const card = list?.querySelector('.google-reviews__card');
      if (!card) return;
      const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0);
      if (!stride) return;
      const left = Math.abs(list.scrollLeft);
      const max = Math.max(0, list.scrollWidth - list.clientWidth);
      const total = list.querySelectorAll('.google-reviews__card').length;
      const position = section.querySelector('.google-reviews__position b');
      if (position) position.textContent = Math.min(total, Math.round(left / stride) + 1);
      const previous = section.querySelector('[data-google-reviews-scroll="previous"]');
      const next = section.querySelector('[data-google-reviews-scroll="next"]');
      if (previous) previous.disabled = left < 2;
      if (next) next.disabled = left >= max - 2;
    }

    function initialize(section) {
      if (section.dataset.googleReviewsReady === 'true') return;
      const list = section.querySelector('.google-reviews__list');
      if (!list) return;
      section.dataset.googleReviewsReady = 'true';
      let frame = 0;
      list.addEventListener('scroll', () => {
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = 0; update(section); });
      }, { passive: true });
      section.querySelectorAll('[data-google-reviews-scroll]').forEach(control => {
        control.addEventListener('click', event => {
          const card = list.querySelector('.google-reviews__card');
          if (!card) return;
          const stride = card.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0);
          const direction = control.dataset.googleReviewsScroll === 'next' ? -1 : 1;
          const immediate = event.detail === 0 || matchMedia('(prefers-reduced-motion: reduce)').matches;
          list.scrollBy({ left: direction * stride, behavior: immediate ? 'auto' : 'smooth' });
        });
      });
      update(section);
    }

    function initializeAll(root = document) {
      if (root.matches?.(selector)) initialize(root);
      root.querySelectorAll(selector).forEach(initialize);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }
    document.addEventListener('shopify:section:load', event => initializeAll(event.target));
    window.addEventListener('resize', () => document.querySelectorAll(selector).forEach(update), { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
